import { render } from "./PeopleCannon.vue?vue&type=template&id=46ccdf9f"
import script from "./PeopleCannon.vue?vue&type=script&lang=js"
export * from "./PeopleCannon.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__